<div class="relative">
  @if (user?.picture?.small?.url) {
    <img class="avatar flex items-center justify-center" [ngClass]="'user-border-color-'+user?.userColor" src="{{user?.picture?.small?.url}}"  />
  }
  @if (!user?.picture?.small?.url) {
    <div class="avatar flex items-center justify-center" [ngClass]="'user-border-color-'+user?.userColor">{{renderShort(user)}}</div>
  }
  @if (user?.online) {
    <div class="user-online"></div>
  }
</div>

